export { ReactComponent as TextBold } from './svgs/bold.svg';
